export const affiliateConstants = {
  ADD_AFFILIATE_REQUEST:              'ADD_AFFILIATE_REQUEST',
  ADD_AFFILIATE_SUCCESS:              'ADD_AFFILIATE_SUCCESS',
  ADD_AFFILIATE_FAILURE:              'ADD_AFFILIATE_FAILURE',

  GET_CUST_SALES_LIST_REQUEST:        'GET_CUST_SALES_LIST_REQUEST',
  GET_CUST_SALES_LIST_SUCCESS:        'GET_CUST_SALES_LIST_SUCCESS',
  GET_CUST_SALES_LIST_FAILURE:        'GET_CUST_SALES_LIST_FAILURE',

  GET_AFFILIATE_REQUEST:              'GET_AFFILIATE_REQUEST',
  GET_AFFILIATE_SUCCESS:              'GET_AFFILIATE_SUCCESS',
  GET_AFFILIATE_FAILURE:              'GET_AFFILIATE_FAILURE',

  DELETE_AFFILIATE_REQUEST:           'DELETE_AFFILIATE_REQUEST',
  DELETE_AFFILIATE_SUCCESS:           'DELETE_AFFILIATE_SUCCESS',
  DELETE_AFFILIATE_FAILURE:           'DELETE_AFFILIATE_FAILURE',

  GET_AFFILIATEDETAIL_REQUEST:        'GET_AFFILIATEDETAIL_REQUEST',
  GET_AFFILIATEDETAIL_SUCCESS:        'GET_AFFILIATEDETAIL_SUCCESS',
  GET_AFFILIATEDETAIL_FAILURE:        'GET_AFFILIATEDETAIL_FAILURE',

  UPDATE_AFFILIATE_REQUEST:        'UPDATE_AFFILIATE_REQUEST',
  UPDATE_AFFILIATE_SUCCESS:        'UPDATE_AFFILIATE_SUCCESS',
  UPDATE_AFFILIATE_FAILURE:        'UPDATE_AFFILIATE_FAILURE',

  GET_AFFILIATE_DASHBOARD_REQUEST:     'GET_AFFILIATE_DASHBOARD_REQUEST',
  GET_AFFILIATE_DASHBOARD_SUCCESS:      'GET_AFFILIATE_DASHBOARD_SUCCESS',
  GET_AFFILIATE_DASHBOARD_FAILURE:        'GET_AFFILIATE_DASHBOARD_FAILURE',

  GET_AFFILIATE_DASHBOARD_BYUSER_REQUEST:     'GET_AFFILIATE_DASHBOARD_BYUSER_REQUEST',
  GET_AFFILIATE_DASHBOARD_BYUSER_SUCCESS:      'GET_AFFILIATE_DASHBOARD_BYUSER_SUCCESS',
  GET_AFFILIATE_DASHBOARD_BYUSER_FAILURE:        'GET_AFFILIATE_DASHBOARD_BYUSER_FAILURE'
 };


// WEBPACK FOOTER //
// ./src/app/redux/constants/affiliateConstants.js